<div class="container pt-0 pt-md-5">
  <div class="row">
      <h2 class="col-12 mb-4 text-center benefit-title">
        {{ "Beneficios Exclusivos para miembros" | translate }}
      </h2>
  </div>
  <div class="row align-items-center">
    <!-- Imagen -->
    <div class="col-12 col-md-6 d-flex mx-auto mt-4">
      <img
        src="{{ '/images/happy-members.png' | blobstorage }}"
        alt="Happy members"
        class="w-100 h-100 object-fit-cover"
      />
    </div>

    <div class="col-12 col-md-6 mt-4 mt-md-0">
      <div
        *ngFor="let benefit of benefits"
        class="d-flex align-items-center mb-3 gap-3"
      >
        <div class="flex-shrink-0">
          <img
            [src]="'/icons/Black/' + benefit.iconName | blobstorage"
            [alt]="benefit.iconName"
            width="40"
            height="40"
          />
        </div>

        <div class="flex-grow-1">
          <span class="benefit-text">
            {{ benefit.text | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
